import Checkbox, { CheckboxAllProps } from "./Checkbox";
import { withLabel } from "composants/withLabel";

export const CheckBoxAndLabel = withLabel<CheckboxAllProps>({ passLabel: true })(Checkbox);
export default CheckBoxAndLabel;
